import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'ScreenIdMstSelectorButton',
  props: {
    name: {
      type: String,
      require: true
    },
    index: {
      type: Number,
      require: false,
      default: 0
    },
    model: {
      type: String,
      require: false,
      'default': () => ''
    },
    disabled: {
      type: Boolean,
      require: false,
      'default': () => false
    },
    overlay: {
      type:Boolean,
      default: () => false,
    }
  },
  data () {
    return {
      loading: true,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      buttonId: state => state.selectScreenIdMstModal.buttonId,
      modalIndex: state => state.selectScreenIdMstModal.index,
      value: state => state.selectScreenIdMstModal.value
    }),
    ...mapGetters({
      getScreenName: 'selectScreenIdMstModal/getScreenName',
    }),

    screenName () {
      return this.getScreenName(this.model)
    },

    showDeleteButton () {
      return this.model ? true : false
    }
  },
  watch: {
    value (to) {
      // 1画面に複数のモジュールが設置された場合の識別処理
      if (to &&
        this.buttonId === this.name &&
        this.index === this.modalIndex) {
        // console.log(this.name, to)
        this.changeScreen(to)
      }
    }
  },
  methods: {
    ...mapActions({
      showSelectScreenIdMstModal: 'selectScreenIdMstModal/show',
      loadModel: 'selectScreenIdMstModal/loadModel',
    }),

    init () {
      this.loading = true

      // データ読出し
      this.loadModel()
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    showScreenSelector () {
      this.showSelectScreenIdMstModal({
        buttonId: this.name,
        index: this.index,
        overlay: this.overlay,
      })
    },

    changeScreen (data) {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        data: data
      })
    },
    deleteScreen () {
      this.$emit('childs-delete', {
        name: this.name,
        index: this.index
      })
    }
  }
}